export default {"src":"/_next/static/media/Joinbit.4822cd76.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};